import { render } from "./createQuestion.vue?vue&type=template&id=5dd72c73&scoped=true"
import script from "./createQuestion.vue?vue&type=script&lang=js"
export * from "./createQuestion.vue?vue&type=script&lang=js"

import "./createQuestion.vue?vue&type=style&index=0&id=5dd72c73&lang=less&scoped=true"
import "./createQuestion.vue?vue&type=style&index=1&id=5dd72c73&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd72c73"]])

export default __exports__